import CountCard from "../components/countCard";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import dollarfill from "../assets/images/dollar-fill.svg"
import { Link, useLocation } from "react-router-dom";
import henceforthApi from "../utils/henceforthApi";
import { GlobalContext } from "../context/Provider";
import { useEffect, useContext, useState } from "react";
import staticDataDashboardSuccess from "../context/actions/auth/staticDataDashboardSuccess";
import { getUserProfileImage } from "../utils/constant_value";

export default () => {
  const [data, setData] = useState({});
  const [reactUser, setResentUser] = useState([]);
  const location = useLocation();
  const searchParam = new URLSearchParams(location.search);
  const { authState, staticDataState, staticDataDispatch, handleError, scrollToTop } =
    useContext(GlobalContext);
  henceforthApi.setToken(authState.access_token);
  const dashboard = staticDataState.dashboard;

  const getDashboardData = async () => {
    try {
      let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const dbData = await henceforthApi.Dashboard.getPagnation(
        searchParam.get("type"),
        timezone
      );
      setData(dbData);
      setResentUser(dbData.recent_users);
      // console.log("dbData", dbData);
      // console.log("recent_users", dbData.recent_users);
      staticDataDashboardSuccess(dbData.data)(staticDataDispatch);
    }
    catch (error) {
      handleError(error)
    }
  }
  useEffect(() => {
    getDashboardData()
  }, [searchParam.get("type")]);

  //Activate And Deactivate
  // const [manageUsers, setManageUsers] = useState({
  //   type: "",
  //   _id: "",
  //   admin_verified: false,
  //   language: "ENGLISH",
  //   account_status: "",
  // });
  // const handleActivate = async (res) => {
  //   console.log("id", res._id);
  //   let data = {
  //     _id: res?._id,
  //     language: "ENGLISH",
  //     account_status:
  //       res?.account_status == "Activated" ? `Deactivated` : `Activated`,
  //   };
  //   try {
  //     const manage_users = await henceforthApi.User.manageUsers(data);
  //     console.log("mmanage users", manage_users);
  //     setManageUsers(data);
  //     {
  //       res?.account_status == "Deactivated"
  //         ? Swal.fire({
  //             title: "Activated",
  //             text: "Account Activated Successfully",
  //             icon: "success",
  //             confirmButtonText: "OK",
  //           })
  //         : Swal.fire({
  //             title: "Deactivated",
  //             text: "Account Deactivated Successfully",
  //             icon: "success",
  //             confirmButtonText: "OK",
  //           });
  //     }
  //   } catch (error) {
  //     console.log(error, "error is ");
  //   }
  // };

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div className="animated fadeInRight">
      <div className="row">
        <Link
          to="/users/1"
          className="col-md-3"
          style={{ textDecoration: "none" }}
        >
          <CountCard
            title="No. of Users"
            count={data?.total_users}
            currency=""
            icon="fas fa-users"
          />
        </Link>
        <Link
          to="/posts/1"
          className="col-md-3"
          style={{ textDecoration: "none" }}
        >
          <CountCard
            title="No. of Posts"
            count={data?.total_posts}
            currency=""
            icon="fas fa-images"
          />
        </Link>
        <Link
          to="/stories/1"
          className="col-md-3"
          style={{ textDecoration: "none" }}
        >
          <CountCard
            title="No. of Stories"
            count={data?.total_stories}
            currency=""
            icon="far fa-photo-video"
          />
        </Link>
        {/* <Link
          to="/reels/1"
          className="col-md-3"
          style={{ textDecoration: "none" }}
        >
          <CountCard
            title="No. of Reels"
            count={data?.total_reels}
            icon="fas fa-play"
          />
        </Link> */}
        <Link
          to="/user-Messages/1"
          className="col-md-3"
          style={{ textDecoration: "none" }}
        >
          <CountCard
            title="No. of User Messages"
            count={data?.total_user_messages}
            icon="fas fa-laptop-code"
          />
        </Link>
        {/* <Link
          to="/reported-posts/1"
          className="col-md-3"
          style={{ textDecoration: "none" }}
        >
          <CountCard
            title="Reported Posts "
            count={data?.total_reported_posts}
            icon="fas fa-folder"
          />
        </Link> */}
        {/* <Link
          to="/reported-reels/1"
          className="col-md-3"
          style={{ textDecoration: "none" }}
        >
          <CountCard
            title="Reported Reels"
            count={data?.total_reported_reals}
            icon="fas fa-folder"
          />
        </Link> */}
        {/* <Link
          to="/reported-stories/1"
          className="col-md-3"
          style={{ textDecoration: "none" }}
        >
          <CountCard
            title="Reported Stories "
            count={data?.total_reported_stories}
            icon="fas fa-folder"
          />
        </Link> */}
        <Link
          to="/transaction/1?filter=SEND"
          className="col-md-3"
          style={{ textDecoration: "none" }}
        >
          {/* <CountCard
            title="Available Balance"
            count={data?.transaction_count}
            icon={dollarfill}
          /> */}
        </Link>

        {/* <Link to='/sales/1' className="col-md-3">
        <CountCard title="Total Earning" count={parseFloat(Number(dashboard.total_earnings).toFixed(10))} currency="BNB" icon="fas fa-folder" />
      </Link> */}
      </div>
      <div className="row">
        <div className="col-md-12" style={{ color: "#000000" }}>
          <div class="ibox">
            <div class="ibox-title">
              <h5 style={{ fontSize: "16px" }}>Registered Users</h5>
            </div>
            <div class="ibox-content">
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr style={{ color: "#000000", fontSize: "14px" }}>
                      <th>Sr. No.</th>
                      <th>Profile</th>
                      <th>Name</th>
                      <th>User Name</th>
                      <th>Email </th>
                      <th>Phone </th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reactUser.map((res, index) => (
                      <tr style={{ fontSize: "14px" }} key={res._id}>
                        <td>
                          {index + 1}
                          .
                        </td>
                        <td className="justify-content-center">
                          <img
                            src={getUserProfileImage(res?.profile_pic)}
                            className="me-2 imageSize"
                            alt="Profile"
                            onError={(e) => {
                              e.currentTarget.onerror = null;
                              e.currentTarget.src = profile_placeholder;
                            }}
                          />
                        </td>
                        <td>{(!res?.full_name == "" || !res?.full_name == null) ? res?.full_name : "Not Available"}</td>
                        <td> {(!res?.username == "" || !res?.username == null) ? res?.username : "Not Available"}</td>
                        <td>{(!res?.email == "" || !res?.email == null) ? res?.email : "Not Available"}</td>
                        <td className={res?.phone_no ? "" : "ml-[20vw]"}>
                          {res?.phone_no 
                            ? `+${res?.country_code || ""} ${res?.phone_no}` 
                            : "-- --"}
                        </td>

                        {/* <td className="ActiveDeactive"> */}
                        {/* <i
                            onClick={() => handleActivate(res)}
                            className={
                              res.account_status == "Activated"
                                ? `fas fa-user-alt`
                                : `fas fa-user-alt-slash`
                            }
                            title={
                              res.account_status == "Activated"
                                ? "Active"
                                : "Deactivated"
                            }
                            style={{ width: "36px" }}
                            aria-hidden="true"
                          ></i> */}
                        {/* </td> */}

                        <td>
                          <Link
                            to={`/user/${res?._id}/1/1?type=posts`}
                            className="btn btn-xs btn-white me-2"
                          >
                            <i className="fas fa-eye me-1"></i>
                            View
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="view-more mb-2">
                  <div className="d-flex align-items-center justify-content-center">
                    <Link
                      to="/users/1"
                      className="btn btn-primary"
                      style={{ fontSize: "14px" }}
                    >
                      View More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
